export default __webpack_public_path__ + "static/media/arrow-right-black.3092b07b.svg";